import { statAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";

const { defineMultiStyleConfig } = createMultiStyleConfigHelpers(
  statAnatomy.keys,
);

const StatTheme = defineMultiStyleConfig({
  baseStyle: {
    container: {
      flex: 0,
      "& dl": {
        display: "flex",
        flexDirection: "column",
        gap: "4px",
      },
      "& dd": {
        whiteSpace: "nowrap",
      },
    },
    label: {
      color: "gray.500",
      textStyle: "smallBold",
      whiteSpace: "nowrap",
    },
    helpText: {
      color: "gray.500",
      textStyle: "smallBold",
    },
  },
  variants: {
    horizontal: {
      container: {
        "& dl": {
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: "4px",
        },
      },
      number: {
        textStyle: "small",
      },
    },
  },
  sizes: {
    lg: {
      number: {
        textStyle: "h1",
      },
      label: {
        textStyle: "smallBold",
      },
    },
    md: {
      number: {
        textStyle: "h2",
      },
    },
    sm: {
      container: {
        fontSize: "12px",
      },
      number: {
        textStyle: "h3",
      },
    },
    xs: {
      container: {
        alignSelf: "center",
        fontSize: "10px",
      },
      helpText: {
        fontSize: "unset",
      },
      number: {
        textStyle: "h4",
      },
    },
    xxs: {
      container: {
        py: "16px",
      },
      number: {
        textStyle: "h6",
      },
      label: {
        textStyle: "small",
        fontWeight: 500,
      },
    },
    overline: {
      label: {
        textStyle: "overline",
        textColor: "gray.400",
      },
      number: {
        textStyle: "body",
      },
    },
  },
});

export default StatTheme;
